<template>
	<ul class="nav notification-list">
		<template v-if="showingNavigation">
			<VueNotificationCard
				:notification="notification"
				v-for="notification in items"
				:key="notification.id"
				@notificationClick="onNotificationClick"
				@dismissClick="onDismissClick"
				@saveClick="onSaveClick"
			/>
		</template>
		<Toast
			class="notification-list__toast-item"
			v-for="toast in activeToasts"
			:key="toast.id"
			:visible="true"
			:state="toast.state"
			:iconClassName="toast.iconClassName"
			:dismissibleTime="toast.dismissibleTime"
			@removed="dismissToastAction(toast.id)"
			@close="dismissToastAction(toast.id)"
			:siteLevel="toast.siteLevel"
			:slim="true"
			:title="toast.title"
			:subtitle="toast.subtitle"
		>
			<template v-slot:bodyMsg>
				<div v-html="toast.message"></div>
			</template>
		</Toast>
	</ul>
</template>

<script>
import VueNotificationCard from './vue-notification-card.vue';
import { mapGetters, mapActions } from 'vuex';
import Toast from '@/components/notifications/toast/toast.vue';

export default {
	name: 'VueNotificationList',
	components: {
		VueNotificationCard,
		Toast
	},
	data() {
		return {};
	},
	props: {
		items: {
			type: Array,
			default: () => []
		},
		showingNavigation: {
			type: Boolean,
			default: true
		}
	},
	async created() {},
	computed: {
		...mapGetters('communicationHub', ['activeToasts'])
	},
	methods: {
		...mapActions('communicationHub', ['dismissToastAction']),
		onNotificationClick() {
			this.$emit('notificationClick');
		},
		onDismissClick(params) {
			this.$emit('dismissClick', params);
		},
		onSaveClick(params) {
			this.$emit('saveClick', params);
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * [Description]
    *
    * Notification / Toast items list
    * Can use SCSS variables = TRUE
*/

.notification-list {
	display: flex;
	flex-direction: column;
	gap: $gutter-md;
	overflow-x: hidden;
	pointer-events: auto;

	/* TOAST STYLES */

	.vue-alerts & {
		max-height: calc(100vh - 84px);
		overflow-y: auto;
		margin-right: $gutter-md;
	}

	&__toast-item {
		::v-deep .toast__close-btn {
			position: absolute;
			font-size: 12px;
		}
	}
}
</style>
